import {usePushRegistration} from "@/hooks/usePushRegistration";

/**
 * Renders nothing. It exists only so the registration effect runs under the <Authenticated> guard
 * without the app layout having to host a background effect next to its navigator.
 */
export function PushRegistration() {
    usePushRegistration();
    return null;
}
